/* src/app/pages/not-found/not-found.component.scss */
a {
  color: #246c27;
}
/*# sourceMappingURL=not-found.component.css.map */
